<template>
  <form class="form">
    <div class="d-flex">
      <div class="sm form-element">
        <FormInput v-model="$v.name.$model"
          id="name"
          :ske="true"
          label="Product naam"

          :vuelidate="$v"
          fieldName="name"
        />
      </div>
      <div class="sm form-element">
        <FormPriceInput
          v-model="$v.price.$model"
          style="margin-left: 0px !important"
          id="price"
          :ske="true"
          label="Prijs"
          :vuelidate="$v"
          fieldName="price"
        />
      </div>
    </div>

    <CardTabs :tabs="tabs" v-model="tabState" class="card-tabs" />
    <template v-if="!modalOpened && isShowing && show">
      <FormRichText v-if="tabState === 'samenvatting'"
        id="short_description"
        :ske="true"
        :vuelidate="$v"
        v-model="$v.short_description.$model"
        field-name="short_description"
      />
      <FormRichText v-else
        id="description"
        :ske="true"
        :vuelidate="$v"
        v-model="$v.description.$model"
        field-name="description"
      />
    </template>

    <SeoFields class="mt-3"
      :url.sync="url"
      :title.sync="seo_meta_title"
      :description.sync="seo_meta_description"
      :initial-product-websites="productWebsites"
      :initial-product="product"
    />

    <div class="checkbox-wrapper mt-3 d-flex justify-content-between align-items-center">
      <FormCheckbox :inline="true" :ske="true" id="featured" v-model="featured">
        Uitgelichte artikel
      </FormCheckbox>

      <span class="ske">
        <button
          type="button"
          class="btn btn-primary"
          id="submit-button"
          @click="save"
        >
          Opslaan
        </button>
      </span>
    </div>
  </form>
</template>

<script>
// productstock are not overwritable

import { required } from "vuelidate/lib/validators";

const fields = [
  "name",
  "short_description",
  "description",
  "buy_price",
  "price",
  "url",
  "discount_percentage",
  "seo_meta_title",
  "seo_meta_description",
];

import ProductListItem from "../ProductListItem.vue";
import FormRichText from "../../Inputs/FormRichText.vue";
import FormInput from "../../Inputs/FormInput.vue";
import FormPriceInput from "../../Inputs/FormPriceInput.vue"
import FormSearchSelector from "../../Inputs/FormSearchSelector.vue";
import FormCheckbox from "/src/components/Inputs/FormCheckbox.vue";
import FormSelect from "/src/components/Inputs/FormSelect.vue";
import CardTabs from "../../../layout/CardTabs.vue";
import setupForm from "@/mixins/setupForm"
import SeoFields from "../../../layout/SeoFields.vue";

import table from "src/mixins/tableFieldOptions";
import fixDecimalCommaNotation from "src/mixins/fixDecimalCommaNotation";
import { mapState, mapGetters, mapMutations } from "vuex";

const decimal = (value) => {
  return (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/)
    ? true
    : false;
};

/*
  price can only be set higher than the default value, never lower.
  If allow_discount is enabled, then verkoop price can be lower up until the value of discount_percentage
*/

/* const notLowerThanDefaultValue = (value, vm) => {
  const recommended = parseFloat((value + "").replace(/,/, "."), 10);
  const buy_price = parseFloat((vm.buy_price + "").replace(/,/, "."), 10);

  if (isNaN(recommended) || isNaN(buy_price)) return false;
  if (vm.allow_discount) {
    const discount = parseFloat(
      (vm.discount_percentage + "").replace(/,/, ".") || 0,
      10
    );
    const discountedBuyPrice = (1 - discount / 100) * buy_price;

    return recommended >= discountedBuyPrice;
  }

  return recommended >= buy_price;
}; */

export default setupForm(fields, {
  mixins: [
    table,
    fixDecimalCommaNotation([
      "price",
      "wholesale_stock",
      "discount_percentage",
    ]),
  ],
  components: {
    FormSelect,
    FormCheckbox,
    CardTabs,
    FormSearchSelector,
    FormInput,
    FormPriceInput,
    ProductListItem,
    SeoFields,
    FormRichText,
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
    editing: {
      type: Boolean,
      required: false,
    },
    isShowing: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: false,
    },

    productWebsites: Array,
    product: Object,
  },
  validations() {
    let price = {
      required,
      decimal,
    };

    /* if (!this.overwrite) {
      price = {
        ...price,

        notLowerThanDefaultValue,
      }
    } */

    return {
      ...fields.reduce(
        (obj, key) => ({
          ...obj,
          [key]: {},
        }),
        {}
      ),

      name: {
        required,
      },
      buy_price: {
        decimal,
      },

      price,
      discount_percentage: {
        decimal,
      },
    };
  },
  data() {
    return {
      tabState: "omschrijving",
      show: false,
      tabs: [
        { name: "Samenvatting", id: "samenvatting" },
        { name: "Omschrijving", id: "omschrijving" },
      ],

      ...fields.reduce(
        (obj, key) => ({
          ...obj,
          [key]: "",
        }),
        {}
      ),
      featured: false,
    };
  },
  async created() {
    this.mapValueToLocalFormData();
  },
  mounted() {
    this.$nextTick(() => this.show = true)
  },
  methods: {
    isValidationFieldUndefined(key) {
      return !this.$v[key] || this.$v[key].$model === undefined;
    },
    mapValueToLocalFormData() {
      const form = this.value || {};

      this.formFields.forEach((key) => {
        // console.log(key, form[key])
        if (!this.isValidationFieldUndefined(key)) {
          this.$v[key].$model = form[key] || "";
        } else {
          this[key] = form[key];
        }
      });
      this.$v.$reset();
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) return;

      this.$emit("save", this.formData);
    },
    getList(arr) {
      return arr.map((item) => item.sub_categories || []).flat();
    },
  },
  computed: {
    ...mapState({
      modalOpened: (state) => state.modal,
    }),

    isAddingNewProduct() {
      return !this.value;
    },

    formFields() {
      return [...fields, "active", "featured"];
    },
    productName() {
      return this.$v.name.$model;
    },
    formData() {
      const obj = {
        ...this.formFields.reduce(
          (obj, key) => ({
            ...obj,
            [key]: !this.isValidationFieldUndefined(key)
              ? this.$v[key].$model
              : this[key],
          }),
          {}
        ),
        ...this.getFixedFloatingNumber,
      };

      /* if (this.overwrite) {
        delete obj.buy_price
      } */

      return obj;
    },
  },
  watch: {
    allow_discount(val) {
      this.discount_percentage = 0;
    },
    value() {
      this.mapValueToLocalFormData();
    },
    productName(productName) {
      if (this.isAddingNewProduct) {
        this.$v.url.$model = encodeURIComponent(
          productName.toLowerCase().replace(/ /g, "-")
        );
      }
    },
  },
}, null, true);
</script>

<style scoped src="@/assets/css/form.css"></style>

<style>
.percentage-wrapper input {
  padding-left: 28px;
}
</style>

<style scoped>
.form {
  margin-bottom: 50px;
}

.checkbox-wrapper {
  margin-bottom: 18px;
}

.percentage-icon {
  position: absolute;
  top: 0;
  left: 0;
  color: #9a9a9a;
}

.col-sm {
  padding: 0 !important;
}
</style>

